import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { AuthorityLevelDrawer } from './AuthorityLevelDrawer';

export const Route = createFileRoute(
    '/console/$orgId/configuration/claims-products/claims/claims-authority/levels/edit/$levelId',
)({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Edit level',
        },
    },
    params: {
        parse({ levelId }) {
            return {
                levelId: BigInt(levelId),
            };
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <AuthorityLevelDrawer action={['edit', Route.useParams().levelId]} />
        </PageController>
    );
}
